import { Container } from "../components/common-components";
import { FormHeader } from "../components/FormHeader";
import { FormFooter } from "../components/FormFooter";
import { ServiceInfo } from "../components/ServiceInfo";
import { PatientInformation } from "../components/PatientInformation";
import { PatientContactInformation } from "../components/PatientContactInformation";
import { AlternateCaregiverInformation } from "../components/AlternateCaregiverInformation";
import { ClassificationofMinorAilment } from "../components/ClassificationofMinorAilment";
import { EducationalInformation } from "../components/EducationalInformation";
import { PrescribingPharmacistInformation } from "../components/PrescribingPharmacistInformation";
import { PharmacyInformation } from "../components/PharmacyInformation";
import { PrescriptionsIssued } from "../components/PrescriptionsIssued";
import { MedicalHistorySection } from "../components/MedicalHistorySection";
import { FollowUpAppointments } from "../components/FollowUpAppointments";
import { PharmacistMonitoringPlans } from "../components/PharmacistMonitoringPlans";
import { NotificationOfService } from "../components/NotificationOfService";
import React, { useContext, useEffect, useState } from "react";
import { FormContextMA } from "../form-context";
import { CoverLetter } from "../components/CoverLetter";
import { ReferralsAndNotifications } from "../components/ReferralsAndNotifications";
import { NotificationContactInformation } from "../components/NotificationContactInformation";
import { AllergyInformation } from "../components/AllergyInformation";
import { ReferralAlertInformation } from "../components/ReferralAlertInformation";
import { AlertConfirmationTypes } from "../../../helpers/constant";

export const PrescribingRecordForm = ({ showReferral = false }) => {
  const { patient, formType, 
    clinicalServiceName, treatment, education, preAssessment, clinicalAssessment, documentation, 
    startDateTime,
    endDateTime } = useContext(FormContextMA);
  const { serviceId } = useContext(FormContextMA);
  const { referralInformations, notificationInformations, notificationType } =
    documentation || {};

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    setNotifications(
      notificationType?.includes("same") && !notificationInformations?.length
        ? referralInformations
        : notificationInformations
    );
  }, [notificationInformations, referralInformations]);

  return (
    <div className="space-y-20">
      {notifications?.length > 0 ? (
        notifications?.map((ref, index) => (
          <React.Fragment key={`notification-${ref?.id || index}`}>
            <Container>
              <CoverLetter referral={ref} isReferral={false} />
            </Container>
            <Container>
              <FormHeader formType={formType} />
              <div className="mx-[0.375in] mt-[0.25in]">
                <ServiceInfo 
                referral={ref} 
                isReferral={false}
                formType = {formType}
                clinicalServiceName = {clinicalServiceName}
                patient = {patient}
                startDateTime = {startDateTime}
                 />
                {/* <NotificationContactInformation referral={ref} /> */}
                <PatientInformation formType = {formType} patient = {patient} preAssessment = {preAssessment} />
                <PatientContactInformation formType = {formType} patient = {patient} />
                <AlternateCaregiverInformation formType = {formType} patient = {patient} />
                <AllergyInformation formType = {formType} patient={patient} clinicalAssessment = { clinicalAssessment}/>
                <ClassificationofMinorAilment formType = {formType} clinicalServiceName={clinicalServiceName} treatment={treatment} />
                <PrescriptionsIssued treatment={treatment} />
                {showReferral && <ReferralAlertInformation />}
                <PharmacistMonitoringPlans formType = {formType} />
                <EducationalInformation />
                <FollowUpAppointments formType={formType} education={education} clinicalServiceName={clinicalServiceName} serviceId={serviceId} />
                <ReferralsAndNotifications formType={formType} documentation ={documentation} />
                <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
              </div>
              <FormFooter />
            </Container>
          </React.Fragment>
        ))
      ) : (
        <>
          <Container>
            <CoverLetter referral={null} isReferral={false} />
          </Container>
          <Container>
            <FormHeader formType={formType} />
            <div className="mx-[0.375in] mt-[0.25in]">
              <ServiceInfo 
                referral={null} 
                isReferral={false}
                formType = {formType}
                clinicalServiceName = {clinicalServiceName}
                patient = {patient}
                startDateTime = {startDateTime} />
              {/* <NotificationContactInformation referral={null} /> */}
              <PatientInformation formType = {formType} patient = {patient} preAssessment = {preAssessment}/>
              <PatientContactInformation formType = {formType} patient = {patient} />
              <AlternateCaregiverInformation formType = {formType} patient = {patient} />
              <AllergyInformation formType = {formType} patient={patient} clinicalAssessment = { clinicalAssessment}/>
              <ClassificationofMinorAilment formType = {formType} clinicalServiceName={clinicalServiceName} treatment={treatment} />
              <PrescriptionsIssued treatment={treatment} />
              {showReferral && <ReferralAlertInformation />}
              <PharmacistMonitoringPlans formType = {formType} />
              <EducationalInformation />
              <FollowUpAppointments formType={formType} education={education} clinicalServiceName={clinicalServiceName} serviceId={serviceId} />
              <ReferralsAndNotifications formType={formType} documentation ={documentation} />
              <PrescribingPharmacistInformation formType ={formType} startDateTime={startDateTime} endDateTime={endDateTime} />
            </div>
            <FormFooter />
          </Container>
        </>
      )}
    </div>
  );
};
